import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { systemImageResolver } from './shared/resolvers/system-image.resolver';
import { SeasonResolver } from './shared/resolvers/season.resolver';
import { GetParticipantResolverService } from './core/resolvers/get-participant.resolver';
import { GetApplicationResolverService } from './core/resolvers/applications/get-application.resolver';
import { GetGenderResolver } from './core/resolvers/get-gender.resolver';
import { GetTribalAffilationResolver } from './core/resolvers/get-tribal-affilation.resolver';
import { GetRelationshipResolver } from './core/resolvers/get-relationship.resolver';
import { GetResidentialResolver } from './core/resolvers/get-residential.resolver';
import { GetApplicationCertificationResolver } from './core/resolvers/applications/get-application-certification.resolver';
import { GetTribalBoundaryResolver } from './core/resolvers/get-tribal-boundary.resolver';
import { GetFiscalYearsResolver } from './core/resolvers/get-fiscal-years.resolver';
import { GetSeasonsResolver } from './core/resolvers/get-seasons.resolver';
import { GetProvidersResolver } from './core/resolvers/get-providers.resolver';
import { GetStateResolver } from './core/resolvers/get-state.resolver';
import { GetCitiesResolver } from './core/resolvers/get-cities.resolver';
import { GetCountiesResolver } from './core/resolvers/get-counties.resolver';
import { GetZipCodeResolver } from './core/resolvers/get-zip-code.resolver';
import { GetLocationResolver } from './core/resolvers/get-locations.resolver';
import { passwordChangeRequiredGuard } from './core/guards/password-change-required.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
    data: {
      showHeader: false,
      showSidebar: false,
    },
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () => import('./features/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
    data: {
      showHeader: false,
      showSidebar: false,
    },
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [passwordChangeRequiredGuard],
  },
  {
    path: 'change-password',
    loadComponent: () => import('./features/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [passwordChangeRequiredGuard],
  },
  {
    path: 'change-password/required',
    loadComponent: () => import('./features/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [MsalGuard],
    data: {
      showSidebar: false,
      passwordChangeRequired: true,
    },
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [MsalGuard, passwordChangeRequiredGuard],
    resolve: {
      providers: GetProvidersResolver,
      fiscalYears: GetFiscalYearsResolver,
      seasons: GetSeasonsResolver,
    },
  },
  {
    path: 'vendor-payments',
    loadComponent: () => import('./features/vendor-payments/vendor-payments.component').then((m) => m.VendorPaymentsComponent),
    canActivate: [MsalGuard, passwordChangeRequiredGuard],
    resolve: {
      providers: GetProvidersResolver,
      fiscalYears: GetFiscalYearsResolver,
    },
  },
  {
    path: 'administration',
    loadChildren: () => import('./features/administration/administration.routes').then((m) => m.ADMIN_ROUTES),
    canActivate: [MsalGuard, passwordChangeRequiredGuard],
    resolve: { systemImages: systemImageResolver },
  },
  {
    path: 'participant/add',
    loadComponent: () => import('./features/participant/profile/participant-profile/participant-profile.component').then((a) => a.ParticipantProfileComponent),
    resolve: {
      genders: GetGenderResolver,
      tribalAffilations: GetTribalAffilationResolver,
      tribalBoundaries: GetTribalBoundaryResolver,
      relationships: GetRelationshipResolver,
      residentials: GetResidentialResolver,
      states: GetStateResolver,
      cities: GetCitiesResolver,
      counties: GetCountiesResolver,
      zipcodes: GetZipCodeResolver,
      locations: GetLocationResolver
    },
    canActivate: [MsalGuard, passwordChangeRequiredGuard],
  },
  {
    path: 'participant/:id',
    loadChildren: () => import('./features/participant/participant.routes').then((r) => r.PARTICIPANT_ROUTES),
    resolve: {
      participant: GetParticipantResolverService,
    },
    canActivate: [MsalGuard, passwordChangeRequiredGuard],
  },
  {
    path: 'participant/:id/application/:applicationId',
    loadComponent: () => import('./features/participant/application/application.component').then((a) => a.ApplicationComponent),
    loadChildren: () => import('./features/participant/application/application.routes').then((r) => r.APPLICATION_ROUTES),
    resolve: {
      participant: GetParticipantResolverService,
      application: GetApplicationResolverService,
      certification: GetApplicationCertificationResolver,
    },
    canActivate: [MsalGuard, passwordChangeRequiredGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('./features/reports/reports.component').then((m) => m.ReportsComponent),
    loadChildren: () => import('./features/reports/reports.routes').then((r) => r.REPORTS_ROUTES),
    canActivate: [MsalGuard, passwordChangeRequiredGuard],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];
